import { Select } from 'antd';
import React from 'react';
import styled from 'styled-components';

/**
 * Chu ky lap, tinh bang so ngay giua hai buoi.
 *
 * So buoi khong nam o day: server tu suy ra tu horizon 6 thang va tran 12 buoi, nen mot
 * lan bam khong the tao ra hang tram lich.
 */
export const REPEAT_OPTIONS = [
  { label: '1 week', value: 7 },
  { label: '2 weeks', value: 14 },
  { label: '4 weeks', value: 28 },
  { label: '6 weeks', value: 42 },
  { label: '8 weeks', value: 56 },
];

type Props = {
  value?: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  placeholder?: string;
};

/**
 * Mac dinh khong chon gi: repeat phai la hanh dong co chu y, khong duoc mac dinh bat.
 */
const RepeatSelect = ({ value, onChange, disabled, placeholder = 'Do not repeat' }: Props) => {
  return (
    <RepeatSelectStyled
      allowClear
      value={value ?? undefined}
      disabled={disabled}
      placeholder={placeholder}
      options={REPEAT_OPTIONS}
      onChange={(next: number | undefined) => onChange(next ?? null)}
      getPopupContainer={(trigger: HTMLElement) => trigger.parentElement || document.body}
    />
  );
};

export default RepeatSelect;

const RepeatSelectStyled = styled(Select<number>)`
  width: 100%;

  .ant-select-selector {
    height: 48px !important;
    align-items: center;
    border-radius: 2px !important;
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10) inset;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    font-family: Poppins;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
  }
`;
